import { restClient } from '../../client';
import { AppointmentRecurring, AppointmentSlotDuration } from '../../resources';


export type DetermineSlotAvailabilityInput = {
  provider_id?: string;
  patient_id?: string;
  start: string;
  timezone: string;
  duration: AppointmentSlotDuration;
  recurring: AppointmentRecurring;
};


export type DetermineSlotAvailabilityOutput = {
  data: {
    slot_availability: {
      available: true;
      error: null;
    } | {
      available: false;
      error: string;
    };
  };
};


export const determineSlotAvailability = (params: DetermineSlotAvailabilityInput) => restClient.request<DetermineSlotAvailabilityOutput>('/api/v1/appointment/determine_slot_availability', {
  method: 'POST',
  data: params,
});
